import React from 'react';

import {useStore} from 'effector-react';
import {TFunction} from 'i18next';
import {useTranslation} from 'react-i18next';

import {mapTableColumns, Table} from 'components/ui-kit/Table2.0';
import {childrenTotalCount$} from 'models/products/detail';
import {Gate, pageNumberChanged, state$} from 'models/products/detail/aggregate-content/table';
import {ProductContentFormattedRow, ProductContentRawRow} from 'types';

interface Props {
    markingCode: string;
    gtin: string | null;
    configFunc: (t: TFunction) => Array<any>;
    dataMapper: (
        data: ProductContentRawRow[] | undefined,
        t: TFunction,
    ) => ProductContentFormattedRow[];
}

export const AggregateContentTable = ({markingCode, gtin, configFunc, dataMapper}: Props) => {
    const {t} = useTranslation();
    const {data, pageNumber, pageSize, isLoading} = useStore(state$);
    const totalCount = useStore(childrenTotalCount$);
    const mappedData = React.useMemo(() => dataMapper(data, t), [dataMapper, data, t]);

    return (
        <>
            <Gate markingCode={markingCode} gtin={gtin} />
            <Table
                columns={mapTableColumns(configFunc(t))}
                data={mappedData}
                totalRowsCount={totalCount}
                pageCount={Math.ceil(totalCount / pageSize)}
                pageIndex={pageNumber}
                onPageChange={pageNumberChanged}
                isLoading={isLoading}
                hideSetting={true}
            />
        </>
    );
};
